import React from "react";
import { Calendar, MapPin, TrendingUp, Sparkles, ChevronRight, Trophy } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../../hooks/useLang";

const RightSidebar = ({ nextEvent, yourRank, recommended }) => {
  const navigate = useNavigate();
  const { urlLanguage } = useLang();

  // The server works out an actual recommendation; this used to throw it away
  // and show the placeholder string to everyone.
  const recText = recommended?.text || "Open a material and pick up where you left off.";
  const recLink = urlLanguage(recommended?.link || "/library");

  return (
    <div className="space-y-4 animate-fade-in">
      {/* Next Event */}
      {nextEvent && (
        <div className="bg-card rounded-2xl border border-border/40 p-5 shadow-sm transition-all duration-300 hover:border-secondary/30">
          <div className="flex items-center gap-2 mb-3 text-muted-foreground text-xs font-bold uppercase tracking-wider">
            <Calendar className="w-4 h-4 text-secondary" />
            <span>Next Event</span>
          </div>
          <p className="font-bold text-foreground text-sm mb-2">{nextEvent.title}</p>
          <div className="flex items-center gap-3 text-xs text-muted-foreground font-medium">
            <span className="flex items-center gap-1">
              <Calendar className="w-3 h-3" />
              {nextEvent.date}
            </span>
            {nextEvent.location && (
              <span className="flex items-center gap-1">
                <MapPin className="w-3 h-3" />
                {nextEvent.location}
              </span>
            )}
          </div>
          {nextEvent.type && (
            <span className="inline-block mt-2 text-[10px] font-bold px-2.5 py-0.5 rounded-full bg-secondary/15 text-secondary border border-secondary/10 uppercase tracking-widest">
              {nextEvent.type}
            </span>
          )}
        </div>
      )}

      {/* Class Rank */}
      {yourRank && (
        <div className="bg-card rounded-2xl border border-border/40 p-5 shadow-sm transition-all duration-300 hover:border-primary/30">
          <div className="flex items-center gap-2 mb-3 text-muted-foreground text-xs font-bold uppercase tracking-wider">
            <Trophy className="w-4 h-4 text-[#d4af37]" />
            <span>Your Rank</span>
          </div>
          <p className="font-black text-foreground text-xl font-display">{yourRank.title}</p>
          <p className="text-xs text-success font-bold mt-1">
            <TrendingUp className="inline w-3 h-3 mr-1" />
            {yourRank.change}
          </p>
        </div>
      )}

      {/* Recommended */}
      <div className="bg-card rounded-2xl border border-border/40 p-5 shadow-sm transition-all duration-300 hover:border-primary/30 flex flex-col justify-between min-h-[140px]">
        <div>
          <div className="flex items-center gap-2 mb-3 text-muted-foreground text-xs font-bold uppercase tracking-wider">
            <Sparkles className="w-4 h-4 text-[#d4af37]" />
            <span>Recommended</span>
          </div>
          <p className="text-xs text-foreground leading-relaxed font-semibold">
            {recText}
          </p>
        </div>

        <button 
          onClick={() => navigate(recLink)}
          className="mt-4 flex items-center gap-1.5 px-4 py-2.5 rounded-xl bg-primary text-primary-foreground font-bold hover:bg-primary/95 transition-all text-xs border-none cursor-pointer shadow-sm group w-full justify-center"
        >
          <span>Start Review</span>
          <ChevronRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
        </button>
      </div>
    </div>
  );
};

export default RightSidebar;
